export default class formConfig {
  // 企业资质资格（企业资质等级详情）
  static configList() {
    return [
      {
        title: "企业资质资格",
        name: "1",
        icon: "",
        tip: "（企业资质等级详情）",
        formConfigList: [
          {
            label: "编号：",
            type: "input",
            value: "levelNum",
            placeholder: "请输入",
            maxlength: 3,
            rule: {
              required: true,
              message: "请填写编号",
              trigger: "blur"
            }
          },
          {
            label: "等级：",
            type: "input",
            value: "level",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写等级",
              trigger: "blur"
            }
          },
          {
            label: "资质类型：",
            type: "select",
            value: "typNum",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507131554050002"
            },
            rule: {
              required: true,
              message: "请选择资质类型",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
  // 企业资质资格（企业资质资格序列详情）
  static corpQualificationList() {
    return [
      {
        title: "企业资质资格",
        name: "1",
        icon: "",
        tip: "（企业资质资格序列详情）",
        formConfigList: [
          {
            label: "资质资格类型：",
            type: "select",
            value: "certTypeNum",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507131554050002"
            },
            rule: {
              required: true,
              message: "请选择资质资格类型",
              trigger: "blur"
            }
          },
          {
            label: "编码：",
            type: "input",
            value: "listCode",
            placeholder: "请输入",
            maxlength: 10,
            rule: {
              required: true,
              message: "请填写编码",
              trigger: "blur"
            }
          },
          {
            label: "序列名称：",
            type: "input",
            value: "listName",
            placeholder: "请输入",
            maxlength: 100,
            rule: {
              required: true,
              message: "请填写序列名称",
              trigger: "blur"
            }
          },
          {
            label: "上级序列：",
            type: "input",
            value: "parentList",
            placeholder: "请输入",
            maxlength: 10,
            rule: {
              required: true,
              message: "请填写上级序列",
              trigger: "blur"
            }
          },
          {
            label: "综合标志：",
            type: "select",
            value: "overAllFlag",
            placeholder: "请输入",
            clearable: true,
            optionData: [
              { name: "非综合", value: "0" },
              { name: "综合", value: "1" },
            ]
          },
        ]
      },
    ];
  }
  // 企业资质资格（企业资质资格专业类别详情）
  static corpTradetypeBound() {
    return [
      {
        title: "企业资质资格",
        name: "1",
        icon: "",
        tip: "（企业资质资格专业类别详情）",
        formConfigList: [
          {
            label: "专业大类",
            type: "slot",
            slotName: "tradeLargeClassName",
            value: "tradeLargeClassName",
            placeholder: "请输入",
            rule: {
              required: true,
              message: "请填写专业大类",
              trigger: "blur"
            }
          },
          {
            label: "专业小类编码：",
            type: "input",
            value: "tradeCategoryCode",
            placeholder: "请输入",
            maxlength: 10,
            rule: {
              required: true,
              message: "请填写专业小类编码",
              trigger: "blur"
            }
          },
          {
            label: "专业小类名称：",
            type: "input",
            value: "tradeCategoryName",
            placeholder: "请输入",
            maxlength: 150,
            rule: {
              required: true,
              message: "请填写专业小类名称",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
}
